import { render, staticRenderFns } from "./ActivateBountyButton.vue?vue&type=template&id=74ac37a5"
import script from "./ActivateBountyButton.vue?vue&type=script&lang=js"
export * from "./ActivateBountyButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports